export default __webpack_public_path__ + "static/EC160N2-f4f42c201ef137057879f1e60fd09b9e.jpg";